(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discount-popup"] && !Shopify.designMode) return;
  try {
    
  const popup = document.querySelector('[data-discount-popup]');
  if (popup) {
    const storageKey = popup.dataset.storageKey;
    const delay = Number(popup.dataset.delay) || 6000;
    const frequency = Number(popup.dataset.frequency) || 604800000;
    const card = popup.querySelector('.discount-popup__card');
    const closeButtons = popup.querySelectorAll('[data-popup-close]');
    const copyButton = popup.querySelector('[data-popup-copy]');
    const codeInput = popup.querySelector('[data-popup-code]');
    const designMode = popup.dataset.designMode === 'true';
    let lastShown = 0;
    try { lastShown = Number(window.localStorage.getItem(storageKey)) || 0; } catch (error) { lastShown = 0; }
    const closePopup = () => {
      popup.hidden = true;
      document.body.style.overflow = '';
      try { window.localStorage.setItem(storageKey, String(Date.now())); } catch (error) {}
    };
    const openPopup = () => {
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      card.focus();
    };
    closeButtons.forEach((button) => button.addEventListener('click', closePopup));
    copyButton.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(codeInput.value);
      } catch (error) {
        codeInput.select();
        document.execCommand('copy');
      }
      copyButton.textContent = copyButton.dataset.copiedLabel;
      window.setTimeout(() => { copyButton.textContent = copyButton.dataset.copyLabel; }, 1800);
    });
    document.addEventListener('keydown', (event) => {
      if (!popup.hidden && event.key === 'Escape') closePopup();
    });
    if (designMode || Date.now() - lastShown >= frequency) {
      window.setTimeout(openPopup, designMode ? 200 : delay);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
